class ChangePasswordController {
    constructor($browser, toastr, AppServiceApi, ChangeOwnPasswordServiceApi) {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.data = {
                oldPassword: '',
                newPassword: '',
                confirmPassword: ''
            };
            this.passwordRules = {
                rules: []
            };
            this.AppServiceApi.passwordRules().then((response) => {
                let passwordRules = response.data;
                this.passwordRules.rules = passwordRules;
            });
        };
        this.ok = () => {
            if (!this.validatePassword()) {
                return;
            }
            let changePasswordViewModel = {
                OldPassword: this.data.oldPassword,
                NewPassword: this.data.newPassword,
                ConfirmPassword: this.data.confirmPassword
            };
            this.ChangeOwnPasswordServiceApi.changePassword(changePasswordViewModel).then((response) => {
                let changePwdResponse = response.data;
                if (changePwdResponse.success) {
                    // On success just close the modal - no more for the user to see or do
                    // Let the callers decide if they want to show a toast
                    this.close();
                    return;
                }
                // Show the errors
                const error = changePwdResponse.errors[0];
                this.toastr.error(error, 'Password Error');
            });
        };
        this.validatePassword = () => {
            if (this.data.oldPassword.length === 0 ||
                this.data.newPassword.length === 0 ||
                this.data.confirmPassword.length === 0) {
                this.toastr.error('You must input your old, new and confirm passwords.', 'Password Error');
                return false;
            }
            if (this.data.newPassword !== this.data.confirmPassword) {
                this.toastr.error('Your new and confirm passwords must be the same.', 'Password Error');
                return false;
            }
            return true;
        };
        this.cancel = () => {
            this.dismiss();
        };
        this.browser = $browser;
        this.toastr = toastr;
        this.AppServiceApi = AppServiceApi;
        this.ChangeOwnPasswordServiceApi = ChangeOwnPasswordServiceApi;
    }
}
angular.module('app').component('changePasswordComponent', {
    bindings: {
        close: '&',
        dismiss: '&'
    },
    templateUrl: 'scripts/app/partials/ChangePassword/change-password.tpl.html',
    controllerAs: 'vm',
    controller: ChangePasswordController
});
